module.exports = __webpack_public_path__ + "assets/img/icon-maopu.b01be093.png";